import { ITranscriptionSourceFileProvider, ITranscriptionSourceFile } from "../interfaces/ITranscriptionSourceFileProvider";
import { IDocumentStorageTranscriptionDescriptor } from "../interfaces/IDocumentStorageTranscriptionDescriptor";
import { IAuthenticationProvider } from "../interfaces/IAuthenticationProvider";
import * as parsing from '../documentStorage/DocumentStorageTranscriptionManagerParsing'
import { GraphGetOneDriveItemByIdRequest } from "../ms-graph/GraphApiCalls";
import { IOneDriveItemInfo, IOneDriveItem } from "../interfaces/IOneDriveItem";
import { TranscriptionSourceFileError, TranscriptionSourceFileErrors } from "../transcriptionManager/TranscriptionManagerErrors";
import * as GraphClientInitOptions from '../ms-graph/GraphClientInitOptions';
import { Client, ClientOptions } from '@microsoft/microsoft-graph-client';
import { IsAuthError } from "../office-js/auth/AuthErrors";
import { LogEventNames } from "../interfaces/ITelemetryLogger";
import { ErrorStringFromException } from "../../utils/utils";

export class OneDriveTranscriptionSourceFileProvider implements ITranscriptionSourceFileProvider {
    private oneDriveItem: IOneDriveItem;
    private authProvider: IAuthenticationProvider;

    public constructor(descriptor: IDocumentStorageTranscriptionDescriptor, authProvider: IAuthenticationProvider) {
        this.oneDriveItem = descriptor.audioOneDriveItem;
        this.authProvider = authProvider;
    }

    private InitGraphClient(): Client {
        let options: ClientOptions = {
            baseUrl: GraphClientInitOptions.GetAuthOptions(this.authProvider).baseUrl,
            fetchOptions: { cache: 'reload' },
            middleware: GraphClientInitOptions.GetDefaultMiddlewareChain(this.authProvider, true /*enableTelemetryHandler*/, LogEventNames.ServiceGraphClientOneDriveItem)
        }
        return Client.initWithMiddleware(options);
    }

    private async GetTranscriptionSourceFileFromOneDriveItem(oneDriveItem: IOneDriveItem): Promise<ITranscriptionSourceFile> {
        try {
            const graphClient: Client = this.InitGraphClient();

            const response = await GraphGetOneDriveItemByIdRequest(graphClient, oneDriveItem.driveId, oneDriveItem.itemId);
            const audioItemInfo: IOneDriveItemInfo = parsing.ParseItemInfoFromGraphResponse(response);

            if (audioItemInfo.downloadUrl == null )
                throw new Error("Didn't get downloadUrl for audio file form Graph API");

            return {
                fileName: audioItemInfo.name,
                audioUrl: audioItemInfo.downloadUrl,
                permanentAudioUrl: audioItemInfo.webUrl
            };
        } catch (error: any) {
            if (error.code == "itemNotFound" || error.code == "accessDenied" || IsAuthError(error))
                throw new TranscriptionSourceFileError(TranscriptionSourceFileErrors.SourceFileNotFound, "Couldn't find source file" + ErrorStringFromException(error));

            if (error.code == "invalidRequest" )
                throw new TranscriptionSourceFileError(TranscriptionSourceFileErrors.InvalidRequest, "Invalid Onedrive Request" + + ErrorStringFromException(error));

            throw error;
        }
    }


    GetSourceFile(): Promise<ITranscriptionSourceFile> {
        return this.GetTranscriptionSourceFileFromOneDriveItem(this.oneDriveItem);
    }
}